import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchServiceDetailsLatestAPI } from "../../../../shared/hooks/useFetchServiceDetails";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";
import { compareString, getServiceAddressFromUser } from "../../Utils/utils";
import { dwLogging } from "../../../../shared/hooks/useFetchLogin";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import DwLogutil from "../../Utils/DwLogutil";

type serviceDetailsInitialStateType = {
  serviceDetails: any;
  loading: boolean;
  error: any;
};
const initialState: serviceDetailsInitialStateType = {
  serviceDetails: null,
  loading: false,
  error: null,
};

export const getserviceDetails = createAsyncThunk(
  "service/details",
  async (user: any) => {
    const { email, billingAccountNumber, serviceAddrId = '' } = user;
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const serviceAddLocal = getServiceAddressFromUser(user);
      const userType = reduxStore?.user?.data;
      const isPostpaidFiber = reduxStore?.brightSpeedUserUtils?.isPostPaidFiberUser;
      const {companyName,sessionId} = reduxStore?.user;
      // New Headers added on 2026-01-07
      if(headers?.flowType === "NA"){
        return;
      }
      let url=API_URLS['getServiceDetails_with_ban']
      const response = await fetchServiceDetailsLatestAPI(
        {
          "": `${url}?ban=${billingAccountNumber}&addressId=${serviceAddrId || serviceAddLocal?.addressId}`,
        },
        headers
      );

      const productTracking = response?.data?.subscriptions?.[0]?.productTracking;  
      response.data.productTrackingExist = Array.isArray(productTracking)
        && productTracking?.length > 0
        && productTracking?.some(obj => obj && Object.keys(obj)?.length > 0);

      const DWLOG=(stepname:any)=>{
            dwLogging(
              {
                "": API_URLS?.dwLoggingUrl,
              },
              {
                sessionId: sessionStorage?.getItem("sessionId") || "",
                stepName: stepname,
                cta: "failed",
                userEmail: localStorage?.getItem("emailID") || "",
                customerType: localStorage?.getItem("companyName") || "",
              },
              headers
            );
          }

      if (Array.isArray(productTracking) && productTracking?.length > 0) {
        productTracking?.forEach((obj, index) => {
          const missingFields = [];

          const isEmpty = (value: any) => !value || value.trim() === "";

          if (isEmpty(obj?.trackingNumber)) missingFields?.push("trackingNumber");
          if (isEmpty(obj?.shipmentStatus)) missingFields?.push("shipmentStatus");
          if (isEmpty(obj?.serviceName)) missingFields?.push("serviceName");
          if (isEmpty(obj?.orderNumber)) missingFields?.push("orderNumber");

          if (missingFields.length > 0) {
            const messageTemplate = EC_DW_LOGGING_STEPS?.eont_value_missing;
            const message = messageTemplate.replace("<missingField>", missingFields.join(", "));
            DWLOG(message);
          }
        });
      }

      const shipmentStepMap: Record<string, number> = {
        "ordered": 1,
        "processing": 1,
        "order processing": 1,
        "shipped": 2,
        "Order shipped": 2,
        "in transit": 3,
        "out for delivery": 3,
        "delivered": 4,
      };

      if (Array.isArray(productTracking) && productTracking.length > 0) {

        // Get the latest orderNumber from the last product in the array
        const latestOrderNumber = productTracking[productTracking.length - 1]?.orderNumber || null;
        response.data.latestOrderNumber = latestOrderNumber;
        
        // Check if all shipmentStatus are "delivered" for this latest order
        const allDelivered = productTracking
          .filter((tracking: any) => tracking.orderNumber === latestOrderNumber)
          .every((tracking: { shipmentStatus?: string }) =>
            tracking.shipmentStatus?.trim()?.toLowerCase() === "delivered"
          );
        response.data.allShipmentsDelivered = allDelivered;

        // Router tracking for latest order
        const routerTracking = productTracking.find(
          (tracking: { serviceType?: string; serviceName?: string; orderNumber?: string }) =>
            tracking?.serviceType?.trim()?.toLowerCase()?.includes("internet") &&
            tracking?.serviceName?.trim()?.toLowerCase() !== "wifi extender" &&
            tracking?.orderNumber === latestOrderNumber
        );
        if (routerTracking) {
          const step = shipmentStepMap[routerTracking.shipmentStatus?.trim()?.toLowerCase()] ?? 1;
          response.data.routerTracking = {
            trackingNumber: routerTracking.trackingNumber ?? "",
            shipmentStep: step ,
            serviceName: "router",
            orderNumber: routerTracking?.orderNumber
          };
        }        

        // Wifi Extender tracking for latest order
        const wifiExtenderTrackings = productTracking.filter(
          (tracking: { serviceType?: string; serviceName?: string; orderNumber?: string }) =>
            tracking?.serviceType?.trim()?.toLowerCase() === "value added services" &&
            tracking?.serviceName?.trim()?.toLowerCase() === "wifi extender" &&
            tracking?.orderNumber === latestOrderNumber
        );

        if (wifiExtenderTrackings.length > 0) {
          const firstExtender = wifiExtenderTrackings[0];
          const shipmentStatus = shipmentStepMap[(firstExtender.shipmentStatus2?.trim()?.toLowerCase() || firstExtender.shipmentStatus?.trim()?.toLowerCase())] ?? 1
          const trackingNumber = firstExtender.trackingNumber2 || firstExtender.trackingNumber
          const orderNumber = firstExtender?.orderNumber2 || firstExtender?.orderNumber;
          response.data.wifiExtenderTracking = {
            trackingNumber: trackingNumber ?? "",
            shipmentStep: shipmentStatus ,
            serviceName: "wifi extender",
            orderNumber: orderNumber,
            isMultiWifiExtender: wifiExtenderTrackings.length > 1,
          };
        }
      }
      
      let ataProdIndex = null;
      if (response?.data?.subscriptions[0]?.serviceDetails?.length > 0) {
        response.data.subscriptions[0].serviceDetails =
          response?.data?.subscriptions[0]?.serviceDetails?.map((item: any) => {
            if (item?.serviceName) {
              item.serviceName = item?.serviceName
                ?.toString()
                ?.trim()
                ?.replace("fQF ", "");
            }
            return item;
          });
      }
      
      if(reduxStore?.user?.isGrandFather){
      response.data.subscriptions[0].serviceDetails= response.data.subscriptions[0].serviceDetails.filter((item:any)=>!compareString(item.serviceName,"controls"));
      // response.data.subscriptions[0].serviceDetails= response.data.subscriptions[0].serviceDetails.filter((item:any)=>!compareString(item.serviceName,"wifi"));
      }
      
      const ataProduct = response?.data?.subscriptions[0]?.serviceDetails?.find(
        (item: any, i: number) => {
          if (
            item?.serviceType?.trim()?.toUpperCase() === "DEVICE TYPE" &&
            item?.serviceState?.trim()?.toUpperCase() === "ACTIVE"
          ) {
            ataProdIndex = i;
            return item;
          }
        }
      );
      
    if (response?.data?.subscriptions?.length > 0) {
      for (let index = 0; index < response?.data?.subscriptions[0]?.serviceDetails?.length; index++) {
        const element = response?.data?.subscriptions[0]?.serviceDetails[index];
        if (element?.serviceState === "Active" &&  element?.serviceName?.toLowerCase()?.includes("inside wire protection")) {
          response.data.iwpServiceExists = true;
        }
      }
    }
 
      if(response?.data?.subscriptions?.length > 0 && response?.data?.subscriptions[0]?.serviceDetails) {
        let arrServices = response?.data?.subscriptions[0]?.serviceDetails?.filter((item: any) => item?.serviceName?.trim() !=="" && item?.serviceState !== "Inactive" && item?.serviceName !== "Quantum Fiber Tech Installation" && item?.serviceType?.toUpperCase() !== "DEVICE TYPE" && item?.isParent !== "false");
        response.data.serviceIDForAxonAPI = arrServices?.length > 0 ? arrServices[0]?.serviceId : ""; 
      }
      if (ataProduct?.serviceName && ataProduct?.serviceId) {
        response.data.ataProduct = ataProduct;
        response.data?.subscriptions[0].serviceDetails?.splice(ataProdIndex, 1);
      }
      // find ProductType logic for timeslot API
      if (
        response?.data?.subscriptions?.length > 0 &&
        response?.data?.subscriptions[0]?.serviceDetails?.length > 0
      ) {
        let internet = false;
        let voice = false;
        for (
          let index = 0;
          index < response?.data?.subscriptions[0]?.serviceDetails?.length;
          index++
        ) {
          const element =
            response?.data?.subscriptions[0]?.serviceDetails[index];
          if (element?.productType?.toUpperCase() === "WA") {
            internet = true;
          } else if (element?.productType?.toUpperCase() === "IL") {
            voice = true;
          }
        }
        if (internet && voice) {
          response.data.productType = "HSI_VOICE";
        } else if (internet && !voice) {
          response.data.productType = "HSI";
        } else if (!internet && voice) {
          response.data.productType = "VOICE";
        }
      }
      //Network settings link display changes
      if (response?.data?.subscriptions?.length > 0 && response?.data?.subscriptions[0]?.serviceDetails?.length > 0) {
        let activeInternet = response?.data?.subscriptions[0]?.serviceDetails?.filter((item: any) => item?.serviceState?.toUpperCase() === "ACTIVE" && item?.isParent?.toUpperCase() === "TRUE" && item?.productType?.toUpperCase() === "WA");
        let activeVoice = response?.data?.subscriptions[0]?.serviceDetails?.filter((item: any) => item?.serviceState?.toUpperCase() === "ACTIVE" && item?.isParent?.toUpperCase() === "TRUE" && item?.productType?.toUpperCase() === "IL");        
        if (activeInternet.length === 0 && activeVoice.length > 0) {
          response.data.voiceOnly = true;
        }
      }
      const pendingService =
        (response?.data?.subscriptions?.length > 0 &&
          response?.data?.subscriptions[0]?.serviceDetails?.find(
            (item: any) => {
              if (
              
               ["INSTALLATION PENDING"]?.includes(
                  item?.serviceState?.toUpperCase() && item?.serviceName?.toLowerCase().includes("internet")
                )
              ) {
                return item;
              }
            }
          )) ||
        null;

        const pendingServiceChange =
        (response?.data?.subscriptions?.length > 0 &&
          response?.data?.subscriptions[0]?.serviceDetails?.find(
            (item: any) => {
              if (
                reduxStore?.user?.data?.currentStatus === "Active" &&
                ["CHANGE PENDING","INACTIVATION PENDING"]?.includes(
                  item?.serviceState?.toUpperCase()
                )
              ) {
                return item;
              }
            }
          )) ||
        null;
        
      const isctlUser = headers?.siteId?.toLowerCase() === "ctl";
      const isFiberUser = headers?.siteId?.toLowerCase() === "qf-ii" || headers?.siteId?.toLowerCase() === "qf" || headers?.siteId?.toLowerCase() === "bs";
      const isUserAccountActive = userType?.currentStatus?.toUpperCase() === "ACTIVE";

      const installationPending = () => {
        const isInstallationPending = response?.data?.subscriptions?.[0]?.serviceDetails?.some((service: { serviceState?: any, serviceName?: any }) =>
            service.serviceState?.toUpperCase().includes("INSTALLATION PENDING") &&
            ["VOICE", "INTERNET"].some((type) => service?.serviceName?.trim().toUpperCase().includes(type))
          );
        const isParentTrueInstallationPending = response?.data?.subscriptions?.[0]?.serviceDetails?.some((service: { serviceState?: any, serviceName?: any, isParent?: any }) =>
            service.isParent?.toUpperCase().includes("TRUE") &&
            service.serviceState?.toUpperCase().includes("INSTALLATION PENDING") &&
            ["VOICE", "INTERNET"].some((type) => service?.serviceName?.trim().toUpperCase().includes(type))
          );
        if ((isFiberUser && isInstallationPending) || (isctlUser && isParentTrueInstallationPending)) {
          localStorage.removeItem("changePending");
          response.data.serviceIsInPending = true;
          const stepName = EC_DW_LOGGING_STEPS?.ppf_pending_installation;
          isPostpaidFiber && DwLogutil({ headers, sessionId, email: user?.email, companyName: companyName, stepName });
        }
      }

      const changesPending = () => {
        const isChangesPending = response?.data?.subscriptions?.[0]?.serviceDetails?.some((service: { serviceState?: any, serviceName?: any }) =>
           (service.serviceState?.toUpperCase().includes("CHANGE PENDING") || service.serviceState?.toUpperCase().includes("INACTIVATION PENDING")) &&
            ["VOICE", "INTERNET","VALUEADDEDSERVICES", "PROTECTION", "SUPPORT", "EXTENDER"].some((type) => service?.serviceName?.trim().toUpperCase().includes(type))
          );
        const isParentTureChangesPending = response?.data?.subscriptions?.[0]?.serviceDetails?.some((service: { serviceState?: any, serviceName?: any, isParent?: any }) =>
            service.isParent?.toUpperCase().includes("TRUE") &&
            (service.serviceState?.toUpperCase().includes("CHANGE PENDING") || service.serviceState?.toUpperCase().includes("INACTIVATION PENDING")) &&
            ["VOICE", "INTERNET"].some((type) => service?.serviceName?.trim().toUpperCase().includes(type))
          );
        if (isUserAccountActive && ((isFiberUser && isChangesPending) || (isctlUser && isParentTureChangesPending))) {
          response.data.pendingServiceChange = true;
        }
      };

      if (response?.data?.subscriptions?.length > 0) {
        changesPending();
        installationPending();
      }
      if (pendingServiceChange?.serviceId) { 
        localStorage.removeItem("changePending");
         response.data.pendingServiceChange = true;
      }

      if (pendingService?.serviceId) {
        localStorage.removeItem("changePending");
        response.data.serviceIsInPending = true;
      } else if (
        !pendingService?.serviceId &&
        serviceAddLocal?.addressId?.includes(localStorage.getItem("changePending"))
      ) {
        response.data.pendingServiceChange = true;
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const serviceDetailSlice = createSlice({
  name: "service/details",
  initialState,
  reducers: {
    clearServiceDetailSlice: (state) => {
      return initialState;
    },
    serviceDetailSliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getserviceDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getserviceDetails.fulfilled, (state, action) => {
      state.serviceDetails = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getserviceDetails.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "service details",
        action.error?.message,
        action?.type
      );
      state.serviceDetails = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const { clearServiceDetailSlice, serviceDetailSliceSetInitialState } =
  serviceDetailSlice.actions;
export default serviceDetailSlice.reducer;
